import { render, staticRenderFns } from "./VesselEdit.vue?vue&type=template&id=0be5baf3&"
import script from "./VesselEdit.vue?vue&type=script&lang=js&"
export * from "./VesselEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports